module.exports = __webpack_public_path__ + "img/ic_question_notice_normal.134d0b75.svg";